import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/admin`,
  withCredentials: true,
});

export const currency = (n, cur = "ZAR") => {
  const sym = cur === "USD" ? "$" : "R";
  return `${sym} ${Number(n || 0).toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
